import { useGetDexFactories } from '@services/api/vaults/farms.api';

const useDexFactories = (chains: number[]) => {
  const { data, isLoading } = useGetDexFactories(chains);

  return {
    dexFactories: data || [],
    isLoading,
  };
};

export default useDexFactories;
